<template>
  <!-- 2.第二步 为ECharts准备一个具备大小（宽高）的Dom -->
  <div id="priceEcharts" style="width: 100%;height:100%;"></div>
</template>

<script>
// import { productPriceTrend } from '@/utils/homeApi'
// 第一步引入echarts
import * as echarts from 'echarts'
export default {
  data() {
    return {
      productPriceTrendMap: [],
      productTypeList: [],
      legendList: [],
      lineListOne: [],
      lineListTwo: [],
      xData: [],
    }
  },
  created() {
  },
  // mounted周期函数里页面上的元素渲染完毕了
  mounted() {
    // this.getProductPriceTrend()
    // this.addChart();
  },
  methods: {
    async getProductPriceTrend() {
      const query = {
        beforeDate: '8',
        afterDate: '3'
      }
      let res = await productPriceTrend(query);
      if (res.code == 200) {
        // this.addChart();
      }

    },
    addChart(rows) {
      // 第三步 3. 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('priceEcharts'))
      // 4.准备数据和配置项
      let option = {
        // "backgroundColor": "#091336",
        "tooltip": {
          trigger: 'axis',
          "backgroundColor": "rgba(3, 9, 24,1)",
          "textStyle": {
            "color": "rgba(255, 255, 255, 1)"
          }
        },
        "dataZoom": [
          {
            "type": "slider",
            "show": false,
            "realtime": true,
            "startValue": 0,
            "endValue": 12,
            "filterMode": "none"
          }
        ],
        "grid": {
          "left": "5%",
          "right": "8%",
          "bottom": '5%',
          "top": '20%',
          "containLabel": true
        },
        "legend": {
          // "icon": "rect",
          "right": "4%",
          "top": '8%',
          "data": [rows.seriesList[0].name, rows.seriesList[1].name],
          "textStyle": {
            fontFamily: 'SOURCEHANSANSCN-REGULAR',
            "color": "#E1E5E6",
            fontSize: 17
          },
          itemWidth: 25, // 图例标记的宽度为 20px
          itemHeight: 10 // 图例标记的高度为 10px
        },
        "xAxis": {
          "type": "category",
          "data": rows.xaxisList,
          "axisLabel": {
            "textStyle": {
              "color": "rgba(153, 153, 153, 1)",
              fontSize: 18,
            },
            margin: 25,
          },
          "axisLine": {
            "lineStyle": {
              "color": "#e5e5e5"
            }
          },
          "axisTick": {
            "show": false
          },
          "splitLine": {
            "show": true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)'
            }
          },
          "boundaryGap": false
        },
        "yAxis": {
          "type": "value",
          "axisLabel": {
            "textStyle": {
              "color": "rgba(153, 153, 153, 1)",
              fontSize: 18
            }
          },
          "axisLine": {
            "show": false
          },
          "axisTick": {
            "show": false
          },
          "splitLine": {
            "show": false
          }
        },
        "series": [
          {
            "name": rows.seriesList[0].name,
            "type": "line",
            "smooth": true,
            "symbol": "circle",
            "symbolSize": 4,
            "itemStyle": {
              "color": "rgb(255, 210, 0)",
            },
            "lineStyle": {
              "normal": {
                "color": "rgb(255, 210, 0)",
                "shadowColor": "rgba(255, 210, 0, .4)",
              }
            },
            "areaStyle": {
              "normal": {
                "color": {
                  "colorStops": [
                    {
                      "offset": 0,
                      "color": "rgba(241, 155, 6, 0.6)"
                    },
                    {
                      "offset": 1,
                      "color": "rgba(255, 178, 57, 0)"
                    }
                  ],
                }
              }
            },
            "data": rows.seriesList[0].data
          }, {
            "name": rows.seriesList[1].name,
            "type": "line",
            "smooth": true,
            symbol: 'circle',
            "symbolSize": 4,
            "itemStyle": {
              "color": "rgba(0, 128, 255, 1)",
            },
            "lineStyle": {
              "normal": {
                "color": "rgba(0, 128, 255, 1)",
                "shadowColor": "rgba(255, 210, 0, .4)",
              }
            },
            "areaStyle": {
              "normal": {
                "color": {
                  "colorStops": [
                    {
                      "offset": 0,
                      "color": "rgba(0, 128, 255, 1)"
                    },
                    {
                      "offset": 1,
                      "color": "rgba(0, 128, 255, 0)"
                    }
                  ],
                }
              }
            },
            "data": rows.seriesList[1].data
          }
        ]
      };
      // 5. 展示数据
      myChart.setOption(option);
      window.addEventListener('resize', () => {
        myChart.resize()
      });
    }
  }
}
</script>

<style lang="less" scoped></style>